import { createContext, useContext } from "react";

interface LoggedUserContextValue {
  CurrentPage: any;
  activePages: any;
  sideBarItens: any;
  avatarMenuItens: any;
}

export const LoggedUserContext = createContext<LoggedUserContextValue>(null!);

export function useLoggedUserContext() {
  return useContext(LoggedUserContext);
}
